import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Button, FormField, FormGrid, IconButton, Text, } from '@dixa/lib-shared-habla';
import { useCallback, useState } from 'react';
import { RecordPlayer } from '../recordPlayer/recordPlayer';
import styles from './dialog.module.scss';
import { TitleError, TitleInput } from './titleInput';
export function RecordDialog({ onUpload, onClose }) {
    const [title, setTitle] = useState('');
    const [titleError, setTitleError] = useState(null);
    const [file, setFile] = useState(null);
    const onUploadClick = useCallback(() => {
        if (!file) {
            return;
        }
        if (!title) {
            setTitleError(TitleError.MissingTitle);
            return;
        }
        onUpload(new File([file], title, { type: file.type }));
        onClose();
    }, [file, onUpload, onClose, setTitleError, title]);
    return (_jsxs("div", Object.assign({ className: styles.root }, { children: [_jsxs("div", Object.assign({ className: styles.head }, { children: [_jsx(Text.Heading, Object.assign({ variant: "heading-3" }, { children: "Record new audio file" })), _jsx(IconButton, { variant: "tertiary", icon: "close", onClick: onClose })] })), _jsxs(FormGrid, Object.assign({ className: styles.form }, { children: [_jsx(FormField, { children: _jsx(RecordPlayer, { onChange: setFile, name: title }) }), _jsx(FormField, { children: _jsx(TitleInput, { value: title, onChange: setTitle, errorCode: titleError }) })] })), _jsx("div", Object.assign({ className: styles.foot }, { children: _jsx(Button, Object.assign({ disabled: !file || !title, onClick: onUploadClick }, { children: "Upload" })) }))] })));
}
